import { rowsToCsv } from '../../creatives/data/csv.js';
import type { WorkflowRunRow } from './runRows.js';

const HEADER = ['Workflow', 'Run', 'Date', 'Owner', 'Outcome', 'Outcome type'];

// One row per outcome, so a run that saved several repeats beside each. A run
// that saved none still lists, which is how it differs from the Outcomes export.
export function runsToCsv(rows: WorkflowRunRow[]): string {
  const lines = rows.flatMap((row) => {
    const shared = [row.workflow, row.title, row.completedAt ?? row.startedAt, row.owner ?? ''];
    if (row.outcomes.length === 0) return [[...shared, '', '']];
    return row.outcomes.map((outcome) => [...shared, outcome.title, outcome.kind]);
  });
  return rowsToCsv([HEADER, ...lines]);
}
